/**
 * Created by Zed on 2019/8/6.
 */

export default {
  ROOT: '/',
  LOGIN: '/login',
  REG: '/reg',
  FORGET: '/forget',
  HOME: '/home',
  PROFILE: '/profile',
  CASTER: '/caster',
  HEALTHY: '/healthy'
};
